export default __webpack_public_path__ + "static/media/digital.f4cd474b.jpg";